import type { UnitSystem } from "../utils/unitFormatting";

const UNIT_SYSTEM_STORAGE_KEY = "rauxa.units.system";

export const unitPreferencesService = {
  read(): UnitSystem {
    if (typeof window === "undefined") return "metric";
    return window.localStorage.getItem(UNIT_SYSTEM_STORAGE_KEY) === "imperial" ? "imperial" : "metric";
  },
  write(unitSystem: UnitSystem) {
    if (typeof window !== "undefined") window.localStorage.setItem(UNIT_SYSTEM_STORAGE_KEY, unitSystem);
  }
};
